import React from "react";
import showModal from "../organisms/Modal";
import Icon from "../atoms/Icon"
import Answer from "../molecules/Answer";
import useSiteData from "../../useSiteData";

export default ({ answer, question }) => {
    const { translations } = useSiteData().pageSettings
    const openModal = () => {
        const element = <Answer answer={ answer } question={ question }/>;
        showModal({ children: element, translations });
    };

    return (
        <button className="m-question a-btn a-btn--no-space a-btn--transparent" onClick={ openModal }>
            <Icon iconName="icon-open-book" className="a-icon a-icon--s m-question__icon" />
            { question }
        </button>
    )
};